import type { ReactNode } from 'react';

import { cn } from '../../utils/cn';

type PageLayoutProps = {
  children: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
};

const maxWidthMap = {
  sm: 'max-w-xl',
  md: 'max-w-3xl',
  lg: 'max-w-5xl',
  xl: 'max-w-7xl',
  full: 'max-w-full',
};

export function PageLayout({ children, maxWidth = 'xl', className }: PageLayoutProps) {
  return (
    <div className={cn('mx-auto w-full px-4 py-6 sm:px-6 lg:px-8 lg:py-8', maxWidthMap[maxWidth], className)}>
      {children}
    </div>
  );
}
